import React from "react";


const HeroSection = ({ heading, subheading, deatailhedaing, img,background, bgColor,button }) => {
  return (
    <div style={{ background }}>
      <div className="h-full flex flex-wrap px-[3%] pt-[20%] pb-[8%] md:px-0 md:py-[12%] md:pb-[4%] lg:py-[8%] lg:pb-[10%] lg:flex-row lg:flex-nowrap md:justify-evenly">
        <div className="py-[2%] flex flex-col    md:mx-[10%] lg:mx-[5.5%] md:justify-center w-full lg:w-[60%]  ">
          <p className="type-eyebrow text-[#FFDB16] pb-[2%]">
            {heading}
          </p>
          <h1 className="type-page-title pb-[2%] text-[#FCFCFD]">
            {subheading}
          </h1>
          <p className="type-body-large text-[#EEF2F6] md:mr-[6%] pb-[2%] text-left my-[10px]">
            {deatailhedaing}
          </p>
        </div>
        <div className=" lg:mr-[3%] md:mt-[2%] lg:mt-[2%]  h-[100%]  lg:w-[40%]">
          <img src={img} alt="" className="object-cover" />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
